import Image from 'next/future/image';
import Link from 'next/link';
import sellOldPhone from '@/public/images/buyback/sell-old-phone.jpeg';

export default function SellBusinessPhonesNotebooks() {
  return (
    <div className="flex flex-wrap rounded bg-white py-4 px-5 sm:py-10 sm:px-12">
      <div className="mb-4 flex w-full flex-col items-center text-left sm:mb-16 md:mb-0 md:w-3/5 md:items-start lg:grow">
        <h2 className="my-4 text-2xl font-bold text-blue-500 sm:text-3xl ">
          Want to sell your old business phones or notebooks
        </h2>
        <p className="mb-8 text-base text-gray-700">
          Sell or trade-in your company's devices with Reebelo. We'll get you
          the best price & make sure they have a great second life.
        </p>
        <div className="block w-full">
          <Link href="/help">
            <a className="rounded-full border-0 bg-blue-500 py-3 px-10 text-sm font-semibold text-white focus:outline-none sm:py-4 sm:px-12">
              Get in Touch
            </a>
          </Link>
        </div>
      </div>
      <div className="w-full md:w-2/5">
        <Image
          className="w-full"
          alt="sell-old-phone"
          width={421}
          height={312}
          src={sellOldPhone}
        />
      </div>
    </div>
  );
}
